import { Fancybox } from '@fancyapps/ui';

export function fancyboxJS() {
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    }); 
    Fancybox.bind("[data-fancybox='tourPageGallery']", {
    }); 
}

fancyboxJS();  